export default __webpack_public_path__ + "static/media/index.9b7c5311.styl";